import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic'; 
/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {

    public list: any;
    public pageMeta: any;
    public expand: false;
    public fields: any = {userType:null,isNotionalPooling:null};
    public logFields: any = {};
    public listFilter: any;
    public selectedRows: Array<any>;
    public selectedRowKeys: Array<string>;
    public App: any;
    public additionalList: Array<any>;
    public additionalListSingle: Array<any>;
    public fresh: string;
    //收票邮箱设置
    emailDrawerVisible: boolean = false;
    emailSetVisible: boolean = false;
    emailList: any[] = [];
    emailPageMeta: any = {};
    emailData: any = {};
}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/Modules.State.ts